import _jsx from "@babel/runtime/helpers/jsx";
var _ModalHeader;
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'reaxl-forms';
import { Modal, ModalBody, ModalFooter, Button, AnimatedButton, Alert, ModalHeader, ModalTitle } from 'reaxl';
import UpdateSavedSearchForm from './UpdateSavedSearchForm/index.js';
function UpdateSavedSearch(_ref) {
  let {
    bookmark,
    onHide = () => {},
    onSubmit = () => {},
    show = false,
    animatedButtonState,
    phone: phoneNumber,
    messages
  } = _ref;
  const handleValidSubmit = data => {
    const {
      bookmarkTitle,
      bookmarkNotes,
      alertByText,
      alertByEmail,
      phone
    } = data;
    onSubmit({
      bookmark: {
        ...bookmark,
        title: bookmarkTitle,
        notes: bookmarkNotes
      },
      alertByText,
      alertByEmail,
      phone
    });
  };
  const renderAlert = _ref2 => {
    let {
      bsStyle,
      message,
      prefix
    } = _ref2;
    return /*#__PURE__*/_jsx(Alert, {
      bsStyle: bsStyle
    }, void 0, prefix && /*#__PURE__*/_jsx("strong", {}, void 0, prefix), message);
  };
  const renderMessages = () => {
    if (messages) {
      if (messages.warning) {
        return renderAlert({
          bsStyle: 'warning',
          message: messages.warning
        });
      }
      if (messages.error) {
        return renderAlert({
          bsStyle: 'danger',
          message: messages.error
        });
      }
    }
    return renderAlert({
      bsStyle: 'success',
      prefix: 'Success! ',
      message: 'Your search has been saved.'
    });
  };
  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    onHide: onHide,
    bsSize: "small",
    "data-cmp": "updateSavedSearch",
    eventId: "save-search",
    trapFocus: true
  }, void 0, /*#__PURE__*/_jsx(Form, {
    onValidSubmit: handleValidSubmit
  }, void 0, _ModalHeader || (_ModalHeader = /*#__PURE__*/_jsx(ModalHeader, {
    className: "text-size-300",
    closeButton: true
  }, void 0, /*#__PURE__*/_jsx(ModalTitle, {}, void 0, "Save Search"))), /*#__PURE__*/_jsx(ModalBody, {}, void 0, renderMessages(), /*#__PURE__*/_jsx(UpdateSavedSearchForm, {
    bookmark: bookmark,
    phone: phoneNumber
  })), /*#__PURE__*/_jsx(ModalFooter, {
    className: "display-flex justify-content-end"
  }, void 0, /*#__PURE__*/_jsx(Button, {
    onClick: onHide
  }, void 0, "No Thanks"), /*#__PURE__*/_jsx(AnimatedButton, {
    type: "submit",
    bsStyle: "primary",
    buttonText: "Update",
    loadedText: "Updated",
    buttonState: animatedButtonState,
    buttonWidth: 124
  }))));
}
export default /*#__PURE__*/React.memo(UpdateSavedSearch);